const INBOX_ROUTE_CACHE_KEY = "asasiasaInboxRouteSnapshot";
const INBOX_ROUTE_CACHE_MAX_AGE = 30 * 1000;

const normalizeInboxSnapshot = (snapshot = {}) => ({
  inbox: {
    unread: snapshot.inbox?.unread || [],
    read: snapshot.inbox?.read || [],
  },
  sectionLimit: snapshot.sectionLimit || 25,
  historyLimit: snapshot.historyLimit || 120,
});

export const writeInboxRouteCache = (snapshot) => {
  try {
    sessionStorage.setItem(
      INBOX_ROUTE_CACHE_KEY,
      JSON.stringify({
        cachedAt: Date.now(),
        snapshot: normalizeInboxSnapshot(snapshot),
      }),
    );
  } catch {
    // Cache is only a navigation optimization.
  }
};

export const readInboxRouteCache = () => {
  try {
    const raw = sessionStorage.getItem(INBOX_ROUTE_CACHE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed?.cachedAt || Date.now() - parsed.cachedAt > INBOX_ROUTE_CACHE_MAX_AGE) {
      sessionStorage.removeItem(INBOX_ROUTE_CACHE_KEY);
      return null;
    }

    return normalizeInboxSnapshot(parsed.snapshot);
  } catch {
    return null;
  }
};

export const clearInboxRouteCache = () => {
  try {
    sessionStorage.removeItem(INBOX_ROUTE_CACHE_KEY);
  } catch {
    // Cache is only a navigation optimization.
  }
};

export const buildInboxNavigationState = () => {
  const snapshot = readInboxRouteCache();
  return snapshot ? { prefetchedInbox: snapshot } : {};
};
